import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, Panel } from "components/bootstrap";
import { Icon } from "components/common";
import AggregationConditionSummary from "./AggregationConditionSummary";
const StyledPanel = styled(Panel)`
  margin-top: 10px;
`;
const StyledButton = styled(Button)`
  margin-left: 15px;
  vertical-align: baseline;
`;
const AggregationConditionsFormSummary = ({
  conditions,
  series,
  expressionValidation = { isValid: true },
  showInlineValidation = false,
  toggleShowValidation
}) => {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledPanel, { header: t("condition_summary.title") }, expressionValidation.isValid ? /* @__PURE__ */ React.createElement("p", { className: "text-success" }, /* @__PURE__ */ React.createElement(Icon, { name: "check_box" }), "\xA0", t("condition_summary.valid")) : /* @__PURE__ */ React.createElement("p", { className: "text-danger" }, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), "\xA0", t("condition_summary.invalid"), /* @__PURE__ */ React.createElement(StyledButton, { bsSize: "xsmall", onClick: toggleShowValidation }, showInlineValidation ? t("condition_summary.hide_errors") : t("condition_summary.show_errors"))), /* @__PURE__ */ React.createElement("b", null, t("condition_summary.preview")), " ", /* @__PURE__ */ React.createElement(AggregationConditionSummary, { series, conditions })));
};
export default AggregationConditionsFormSummary;
